import { useEffect } from 'react';

declare global {
  interface Window {
    $crisp?: unknown[];
    CRISP_WEBSITE_ID?: string;
  }
}

const CRISP_WEBSITE_ID =
  import.meta.env.VITE_CRISP_WEBSITE_ID ?? 'adb290b2-2324-4d8a-a3d6-b5e365c98090';
const CRISP_SCRIPT_ID = 'crisp-chat-script';

export const loadCrisp = () => {
  if (typeof document === 'undefined') return false;
  if (!CRISP_WEBSITE_ID) {
    console.warn('Crisp Website ID not found');
    return false;
  }

  window.$crisp = window.$crisp || [];
  window.CRISP_WEBSITE_ID = CRISP_WEBSITE_ID;

  if (!document.getElementById(CRISP_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = CRISP_SCRIPT_ID;
    script.async = true;
    script.src = 'https://client.crisp.chat/l.js';
    document.head.appendChild(script);
  }

  return true;
};

export const useCrispChat = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return;
    loadCrisp();
  }, [enabled]);
};
